import { downloadCreditApplicationDocuments } from 'common/api/creditApplications';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import { SET_IS_DOWNLOADING } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (id, type, fileName) => (dispatch) => {
    if (!id || !fileName) return;

    dispatch(creditFileActions[SET_IS_DOWNLOADING](true));

    downloadCreditApplicationDocuments(id, type)
        .then((response) => {
            dispatch(creditFileActions[SET_IS_DOWNLOADING](false));
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        })
        .catch((error) => {
            dispatch(creditFileActions[SET_IS_DOWNLOADING](false));
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
